// Aliquota interna de cada estado, em %. Lida celula a celula da aba ICMS_INT
// do Simulador (chave grossa, coluna A:B) em 06/09/2026 -- dado medido, nao
// arredondado. Fonte: C:\Users\monam\Documents\Simulador - Mavalerio - 2026
// -(carlos).xlsx. E lei publica: nao muda por representada, so muda se o
// estado mudar a aliquota -- atualizar aqui e um deploy normal.
export const ICMS_INTERNO_POR_UF: Readonly<Record<string, number>> = {
  AC: 19, AL: 21.5, AM: 20, AP: 18, BA: 19, CE: 20, DF: 20, ES: 17, GO: 17,
  MA: 20, MG: 18, MT: 17, MS: 17, PA: 19, PB: 18, PE: 18, PI: 21, PR: 19.5,
  RJ: 22, RN: 18, RO: 19.5, RR: 20, RS: 17, SC: 17, SE: 22, SP: 18, TO: 20,
}
